import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Tooltip/TooltipUsage.mdx";

import Examples from "../../Docs/Components/Tooltip/TooltipExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Tooltip"
            description="Display additional information related to something with a tooltip."
            apiSources={["azure-devops-ui/Components/TooltipEx/Tooltip.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;